export const ShipmentsActionTypes = {
    API_RESPONSE_SUCCESS: '@@shipments/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@shipments/API_RESPONSE_ERROR',
    GET_ALL_SHIPMENTS: '@@shipments/GET_ALL_SHIPMENTS',
    GET_SHIPMENT_SURCHARGES: '@@shipments/GET_SHIPMENT_SURCHARGES',
    GET_NON_SHIPMENT_SURCHARGES: '@@shipments/GET_NON_SHIPMENT_SURCHARGES',
    GET_SHIPMENT_BY_EXTERNAL_ORDER_ID: '@@shipments/GET_SHIPMENT_BY_EXTERNAL_ORDER_ID',
    GET_ORDER: '@@shipments/GET_ORDER',
    GET_ALL_SHIPMENTS_REPORT: '@@shipments/GET_ALL_SHIPMENTS_REPORT',
    CREATE_MANIFEST: '@@shipments/CREATE_MANIFEST',
    RATE_SHIPMENTS: '@@shipments/RATE_SHIPMENTS',
    RESET_STATE: '@@shipments/RESET_STATE',
    RESET_ALL_ERRORS: '@@shipments/RESET_ALL_ERRORS',
};
